
import { Component } from '@angular/core';
import { ShareMenuComponent } from '../share-menu-component';

@Component({
  standalone: false,
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html'
})
export class SidebarNavComponent extends ShareMenuComponent {

 
}

